import type { PersonalInfoProps } from '@openeducation/pp-rn-shared-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TextInput } from '../../atoms';
import { InputRow } from '../../molecules';
import { FormSection } from '../../templates';

export const PersonalInfo = ({
  formData,
  fields,
  withCardStyle,
}: PersonalInfoProps) => {
  const { t } = useTranslation();
  const { isFullNameEnabled, isEmailEnabled, isCountryEnabled } = fields;

  return (
    <FormSection title={t('title.personal_info')} withCardStyle={withCardStyle}>
      {isFullNameEnabled && (
        <InputRow label={t('input.full_name.label')}>
          <TextInput name="fullName" value={formData.fullName} disabled />
        </InputRow>
      )}
      {isEmailEnabled && (
        <InputRow label={t('input.email.label')}>
          <TextInput
            name="email"
            value={formData.email}
            placeholder={t('input.email.label') as string}
            disabled
          />
        </InputRow>
      )}
      {isCountryEnabled && (
        <InputRow label={t('input.country.label')}>
          <TextInput
            name="country"
            value={t(`country.${formData.country}`) as string}
            disabled
          />
        </InputRow>
      )}
    </FormSection>
  );
};

export default PersonalInfo;
